const axios = require('axios').default;

const instance = axios.create({
    baseURL: 'https://version-api.smsmart.net'
    // baseURL: 'http://192.168.31.114:8300'
});

instance.interceptors.response.use(function (response) {
    const data = response.data
    if (data.code === 401) {
        return Promise.reject(data);
    }
    return data
}, function (error) {
    return Promise.reject(error);
});

/**
 * 产品列表
 */
export function pList(params) {
    return instance.get("/h5/video/pList", params)
}


/**
 * 产品安装视频列表
 */
export function vList(params) {
    return instance.get("/h5/video/vList", {params})
}

/**
 * 产品资料列表
 */
export function resList(params) {
    return instance.get("/h5/video/resList", {params})
}